// local paths of a content category, under its root (/kbeauty); brand and product are route parameters:
//   ''                      the category home
//   words/<term>            a word page
//   <brand>                 a brand page
//   <brand>/<product>       a product guide
// 'words', 'culture', 'learn' and 'about' are reserved and can never be brand slugs (John, 2026-11-04: "shorter")
export const localPaths = {
    home: '',
    words: 'words',
};

export const RESERVED_SLUGS = ['words', 'culture', 'learn', 'about'];
